import React from "react";
var __jsx = React.createElement;
import { AtomicBlockType } from '@uno/common-cms';
import { SelectedBlockWrapper } from 'components/common/RichTextEditor/CompositeDecorator/SelectedBlockWrapper';
import { getAtomicBlockType, getIsBlockSelected } from 'components/common/RichTextEditor/util/block';
import { AffiliationBlock } from '../AffiliationBlock';
import { BeopBlock } from '../BeopBlock';
import { EmbedBlock } from '../EmbedBlock';
import { ImageBlock } from '../ImageBlock';
import { RecipeBlock } from '../RecipeBlock';
import { SlideshowEmbedBlock } from '../SlideshowEmbedBlock';
import { VideoBlock } from '../VideoBlock';

var EmptyBlock = function EmptyBlock() {
  return __jsx(React.Fragment, null, "Empty");
};

var getAtomicComponent = function getAtomicComponent(type) {
  switch (type) {
    case AtomicBlockType.AFFILIATION:
      {
        return AffiliationBlock;
      }

    case AtomicBlockType.BEOP:
      {
        return BeopBlock;
      }

    case AtomicBlockType.EMBED:
      {
        return EmbedBlock;
      }

    case AtomicBlockType.IMAGE:
      {
        return ImageBlock;
      }

    case AtomicBlockType.RECIPE:
      {
        return RecipeBlock;
      }

    case AtomicBlockType.SLIDESHOW_EMBED:
      {
        return SlideshowEmbedBlock;
      }

    case AtomicBlockType.VIDEO:
      {
        return VideoBlock;
      }

    default:
      return EmptyBlock;
  }
};

var AtomicBlock = function AtomicBlock(_ref) {
  var block = _ref.block,
      blockProps = _ref.blockProps;
  var contentState = blockProps.editorState.getCurrentContent();
  var atomicBlockType = getAtomicBlockType(block, contentState);
  var isBlockSelected = getIsBlockSelected(block);
  var Block = getAtomicComponent(atomicBlockType)({
    block: block,
    blockProps: blockProps
  });
  return __jsx(SelectedBlockWrapper, {
    isSelected: isBlockSelected
  }, Block);
};

export default AtomicBlock;